import { render } from "./CompetitionYoutubeControls.vue?vue&type=template&id=f8f6a538&scoped=true"
import script from "./CompetitionYoutubeControls.vue?vue&type=script&lang=js"
export * from "./CompetitionYoutubeControls.vue?vue&type=script&lang=js"

import "./CompetitionYoutubeControls.vue?vue&type=style&index=0&id=f8f6a538&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f6a538"]])

export default __exports__